module.exports = __webpack_public_path__ + "static/img/prize-2-mobile.a057b432.png";